import React, { useContext } from 'react';
import './ReviewOptionsCard.module.scss';
import Button from 'components/UI/Button/Button';
import { OverviewContext } from '../../Views/Overview';

type ReviewOptionsCardProps = {
  type: 'dreams' | 'reflection' | 'project' | 'review';
  dreamSelectModal?: React.ReactNode;
};

export default function ReviewOptionsCard({
  type,
  dreamSelectModal,
}: ReviewOptionsCardProps) {
  // TODO: add translations
  const {
    isLockedProject,
    setIsReflections,
    isRequested,
    setProjectModalIsOpen,
    setReviewerModalIsOpen,
    isProjectAdmin,
  } = useContext(OverviewContext);
  return (
    <div styleName={`wrapper ${type === 'review' ? 'review' : ''}`}>
      <div styleName={`top ${type === 'review' ? 'review' : ''}`}>
        {type === 'review' && (
          <img src="/images/beoordeling.svg" alt="Beoordeling" />
        )}
        <h2>
          {type === 'dreams'
            ? 'Dromen koppelen'
            : type === 'reflection'
            ? 'Reflectie bijwerken'
            : type === 'project'
            ? 'Project op slot zetten'
            : 'Klaar voor de beoordeling?'}
        </h2>
        <p>
          {type === 'dreams'
            ? 'Heeft dit project bijgedragen aan één van je dromen? Koppel hem dan snel!'
            : type === 'reflection'
            ? 'Ben je toch nog niet helemaal tevreden met je reflectie? Pas deze dan nog aan voor je het project gaat laten beoordelen.'
            : type === 'project'
            ? 'Om een project te kunnen laten beoordelen moet deze op slot staan. Als je een project op slot zet kunnen jij en je eventuele groepsgenoten het project alleen nog maar bekijken. Het bijwerken van je reflectie blijft nog wel mogelijk.'
            : 'Ben je helemaal klaar om dit project door je docent te laten beoordelen? Klik dan snel hier om een beoordeling aan te vragen door jouw docent(en). Hierna is het bijwerken van reflecties niet meer mogelijk.'}
        </p>
      </div>
      <div styleName="bottom">
        {type === 'dreams' && dreamSelectModal}
        {type === 'project' && (
          <Button
            inactive={isLockedProject && isRequested}
            onClick={() => setProjectModalIsOpen && setProjectModalIsOpen(true)}
          >
            {isLockedProject && isRequested
              ? 'Project staat op slot'
              : isLockedProject && !isRequested
              ? 'Op slot zetten annuleren'
              : 'Project op slot zetten'}
          </Button>
        )}
        {type === 'reflection' && (
          <Button inactive={isRequested} onClick={() => setIsReflections(true)}>
            {isRequested ? 'Beoordeling aangevraagd' : 'Reflectie bijwerken'}
          </Button>
        )}
        {type === 'review' && (
          <Button
            onClick={() =>
              setReviewerModalIsOpen && setReviewerModalIsOpen(true)
            }
            inactive={!isLockedProject || isRequested}
          >
            {isLockedProject && isProjectAdmin && !isRequested
              ? 'Beoordeling aanvragen'
              : !isLockedProject && !isProjectAdmin && !isRequested
              ? 'Nog niet vergrendeld door de projectleider'
              : isRequested
              ? 'Beoordeling aangevraagd'
              : !isLockedProject
              ? 'Zet het project eerst op slot'
              : 'Beoordeling aanvragen'}
          </Button>
        )}
      </div>
    </div>
  );
}
